// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Role$ReactHooksTemplate = require("./role.res.js");

function UserRoleItem(props) {
  return JsxRuntime.jsx("p", {
              children: Role$ReactHooksTemplate.name(props.role),
              className: "capitalize px-10-px py-3-px bg-teal-200"
            });
}

var make = UserRoleItem;

exports.make = make;
/* react/jsx-runtime Not a pure module */
